import {Injectable} from '@angular/core';
import {DEFAULT_HIGH_THRESHOLD, DEFAULT_MINUTES_TO_NEXT_TASK} from '../constants/parks.constants';

@Injectable()
export class ParkUtil {

  getKingdomId(areaId) {
    const segments = this._getSegments(areaId);

    return segments && segments.length > 1 && segments[1];
  }

  getWorldId(areaId) {
    const segments = this._getSegments(areaId);

    return segments && segments.length > 0 && segments[0];
  }

  getAllActiveAreasForWorld(world) {
    let areas = [];

    if (world && world.kingdoms) {
      world.kingdoms.map(kingdom => {
        if (kingdom && kingdom.active !== false && kingdom.lands) {
          kingdom.lands.map(land => {
            if (land && land.active !== false) {
              areas.push(land);
            }
          });
        }
      });
    }

    return areas;
  }

  getAllActiveKingdomsForWorld(world) {
    let kingdoms = [];

    if (world && world.kingdoms) {
      world.kingdoms.map(kingdom => {
        if (kingdom && kingdom.active !== false) {
          kingdoms.push(kingdom);
        }
      });
    }

    return kingdoms;
  }

  getAreaThreshold(area) {
    return (area && area.taskConfig && area.taskConfig.highThreshold) || DEFAULT_HIGH_THRESHOLD;
  }

  getAreaMinutesToNextTask(area) {
    return (area && area.taskConfig && area.taskConfig.minutesToAssignNextTask) || DEFAULT_MINUTES_TO_NEXT_TASK;
  }

  private _getSegments(areaId) {
    return areaId.split('-');
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/util/park.ts